<!-- tokens-sessions.component.html -->
<app-page-layout
  [pageTitle]="'Tokens & Sessions'"
  [subtitle]="'Manage and monitor OAuth tokens, sessions, and their granted scopes.'">

  <!-- Actions Bar -->
  <div page-actions class="flex items-center gap-2">
    <p-toast/>
    <p-button
      label="Issue Scoped Token"
      icon="pi pi-plus"
      (onClick)="openIssueTokenDialog()"
      severity="primary"
      size="small"
      outlined
    ></p-button>
  </div>

  <!-- Filters -->
  <div class="flex justify-between items-center mb-4">
    <div class="flex items-center gap-3">
      <!-- Search -->
      <div class="relative w-72">
        <p-iconField iconPosition="left" class="w-72">
          <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
          <input
            type="text"
            pInputText
            placeholder="Search tokens..."
            [(ngModel)]="searchTerm"
            (input)="filterTokens()"
            class="w-full"
          />
        </p-iconField>
      </div>

      <!-- Status Filter -->
      <div class="relative w-48">
        <p-select
          [(ngModel)]="statusFilter"
          [options]="statusFilterOptions"
          optionLabel="label"
          optionValue="value"
          (ngModelChange)="filterTokens()"
          appendTo="body"
          class="w-full"
          placeholder="Filter by Status"
          [showClear]="true"
        >
        </p-select>
      </div>
    </div>
  </div>
  <p-confirmDialog></p-confirmDialog>

  <!-- State Container -->
  <app-state-container
    [state]="viewState()"
    loadingMessage="Loading tokens..."
    loadingSubMessage="Please wait while we fetch your tokens"
    emptyIcon="pi-key"
    emptyTitle="No tokens found"
    [emptyMessage]="emptyStateMessage()"
    [showEmptyAction]="false"
    [showClearFilters]="showClearFilters()"
    [errorMessage]="errorMessage()"
    (clearFilters)="clearFilters()"
    (retry)="retryLoad()"
  >
    <!-- Tokens Table -->
    <div class="bg-white dark:bg-zinc-950 rounded-lg border border-surface-200 dark:border-zinc-800">
      <p-table
        [value]="filteredTokens()"
        [loading]="loading()"
        sortMode="single"
        (onSort)="onSort($event)"
        [rowHover]="true"
      >
        <ng-template pTemplate="header">
          <tr class="bg-surface-100 dark:bg-zinc-900 text-surface-600">
            <th (click)="onSort({field:'subject'})" pResizableColumn style="min-width:160px;" class="cursor-pointer group bg-surface-100 dark:bg-zinc-900">
              <div class="flex items-center justify-between text-surface-700 dark:text-zinc-200">
                <span>Subject</span>
                <i class="pi pi-arrow-down transform transition-all duration-200"
                   [ngClass]="{
                     'opacity-0 group-hover:opacity-100': sortField !== 'subject' || sortOrder === 0,
                     'rotate-180 opacity-100': sortField === 'subject' && sortOrder === -1,
                     'opacity-100': sortField === 'subject' && sortOrder === 1
                   }">
                </i>
              </div>
            </th>

            <th pResizableColumn style="min-width:150px;" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Identity Group
            </th>

            <th pResizableColumn style="min-width:150px;" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Audience Group
            </th>

            <th pResizableColumn style="min-width:140px;" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Granted Scope
            </th>

            <th pResizableColumn style="min-width:120px;" class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Status
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-token>
          <tr class="border-t border-surface-200 dark:border-surface-700 hover:bg-surface-50 dark:hover:bg-surface-800 transition">
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300 font-medium">
              {{ token.subject }}
            </td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">
              {{ token.identityGroup }}
            </td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">
              {{ token.audienceGroup }}
            </td>
            <td class="px-4 py-2">
              <span class="inline-block px-2 py-1 rounded text-xs font-mono bg-surface-100 dark:bg-surface-800 text-surface-700 dark:text-surface-300 border border-surface-200 dark:border-surface-600">
                {{ token.scope }}
              </span>
            </td>
            <td class="px-4 py-2">
              <span
                class="px-2 py-0.5 rounded text-xs font-medium"
                [ngClass]="{
                  'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300': token.status === 'Active',
                  'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300': token.status === 'Expiring Soon',
                  'bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300': token.status === 'Expired' || token.status === 'Revoked',
                  'bg-gray-200 text-gray-600 dark:bg-surface-700 dark:text-surface-300': token.status === 'Inactive'
                }"
              >
                {{ token.status }}
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </app-state-container>
</app-page-layout>